export class MenuItemImageValidator {
    static readonly ACCEPTED_MIME_TYPES = ["image/jpeg", "image/png"];
    static readonly MAX_FILE_SIZE = 1024 * 1024 * 5; // 5MB

    static validate(file: Express.Multer.File) {
        if (!this.ACCEPTED_MIME_TYPES.includes(file.mimetype)) {
            throw new Error("Invalid file type");
        }

        if (file.size > this.MAX_FILE_SIZE) {
            throw new Error("File size too large. Maximum size is 5MB.");
        }
    }
}
